import React from 'react';
import 'twin.macro';
import { Link } from 'react-router-dom';

interface HintLink {
  text: string;
  to: string;
  external?: boolean;
}

interface Props {
  title?: string;
  children?: React.ReactNode;
  icon?: any;
  className?: string;
  link?: HintLink;
}

export function Hint(props: Props) {
  const { title, children, icon, className, link } = props;

  return (
    <div
      tw="flex gap-x-2 border border-dashed border-neutral-quiet text-muted rounded-lg py-2 px-4 max-w-4xl"
      className={className}
    >
      {icon}
      <div tw="flex items-center gap-2 flex-wrap">
        {title && <span tw="font-semibold">{title}</span>}
        {children}
        {link && (
          <Link to={link.to} target={link.external ? '_blank' : undefined}>
            {link.text}
          </Link>
        )}
      </div>
    </div>
  );
}
